import { Logger, LoggerService } from '@Shared/logger';
import { AUTH0_CONST, Auth0Service } from '@Modules/auth_module';
import { PipelineContext, PipelineStep } from '@Modules/pipeline_module/_base';
import { UrlUtil } from '@Shared/utils';
import { CheckAuthStatusStep } from '.';

export class ParseAuthRedirectStep implements PipelineStep {
  private auth0Service: Auth0Service;
  private Logger: Logger = LoggerService.createLogger('ParseAuthRedirectStep');

  constructor() {
    this.Logger.trace('****  CTOR ****');
  }
  async execute(context: PipelineContext): Promise<PipelineStep | null> {
    this.Logger.trace('Executing....', context);
    this.auth0Service = Auth0Service.Instance;

    return await this.auth0Service.AuthClient.handleRedirectCallback()
      .then((res) => {
        this.Logger.trace('Auth0 handleRedirectCallback result', res);
        if (res.appState) {
          this.Logger.trace(
            'Auth0 handleRedirectCallback appState',
            res.appState,
          );
        }
        UrlUtil.removeQueryParam(AUTH0_CONST.parseResultParamCode);
        UrlUtil.removeQueryParam(AUTH0_CONST.parseResultParamState);
        context.showEntitlementCheckScreen = true;
        return new CheckAuthStatusStep();
      })
      .catch((error) => {
        this.Logger.error('Error handling Auth0 redirect callback', error);
        return null;
      });
  }
}
